<!-- Side menu and router outlet -->
<side-menu></side-menu>
<router-outlet></router-outlet>

<!-- Modal and loader overlays -->
<message-container></message-container>
<modal-container></modal-container>
<loader></loader>